import initVueApp from './vueApp';
import initTheMenu from './vueTheMenu';
import initTheSearch from './vueTheSearch';
import initCartRecommendations from './vueCartRecommendations';
import { EventBus } from './vue';
import EventBusConfig from './config/eventBusConfig';

initVueApp();
initTheMenu();
initTheSearch();
initCartRecommendations();

export {
  EventBus,
  EventBusConfig,
};
